import React, {useEffect, useState} from 'react';
import {CommonServerSideParams} from '@/app/types/CommonServerSideParams';
import {OnlyBrowserPageProps} from '@/layouts/web/types/OnlyBrowserPageProps';
import {SSGPageProps} from '@/layouts/web/types/SSGPageProps';
import ReactDivWebMain from '@/modules/core/reactDivWeb/components/Web/Main/Main';
import WebLayout from '@/layouts/web/components/WebLayout';
import {
  // getWebLayoutStaticPaths,
  getWebLayoutStaticProps,
} from '@/layouts/web/webLayoutSSG';
// import useCustomer from '@/modules/core/data/hooks/useCustomer';
// import { Customer } from '@/modules/core/data/types/Customer';
import {createLogger} from '@/modules/core/logging/logger';
import {
  GetStaticPaths,
  GetStaticProps, GetStaticPropsResult,
  NextPage,
} from 'next';

import ReactDivWebAnnouncementTopBar from '@/modules/core/reactDivWeb/components/Announcements/TopBar/TopBar';

import {StaticPropsInput} from '@/app/types/StaticPropsInput';
import {getDashboardContentEditorLayoutStaticProps} from '@/layouts/dashboard/contentEditor/dashboardContentEditorLayoutSSG';
import {getReactDivApiConfig} from '@/modules/core/reactDivAPI/utils/getApiConfig';
import getSystemShellBySingularAPIID
  from '@/modules/core/reactDivAPI/utils/queries/system/getSystemShellBySingularAPIID';
import getShelledPageBySingularAPIID from '@/modules/core/reactDivAPI/utils/queries/web/getShelledPageBySingularAPIID';
import deepmerge from 'deepmerge';
import getClientProjectContentBySystemShellID
  from '@/modules/core/reactDivAPI/utils/queries/web/getClientProjectContentBySystemShellID';
import getSystemShelledFieldsBySystemShellID
  from '@/modules/core/reactDivAPI/utils/queries/system/getSystemShelledFieldsBySystemShellID';
import Annoucement from "@/components/centralbrisbanedental/Announcement";
import Topbar from "@/components/centralbrisbanedental/Topbar";
import NavBar from "@/components/centralbrisbanedental/NavBar/NavBar";
import Hero from "@/components/centralbrisbanedental/Hero/Hero";
import AppointmentRequestForm
  from "@/components/centralbrisbanedental/userActions/AppointmentRequestForm/AppointmentRequestForm";
import CTABannerStandard from "@/components/centralbrisbanedental/CTABannerStandard/CTABannerStandard";
import CTABannerImageDescriptive
  from "@/components/centralbrisbanedental/CTABannerImageDescriptive/CTABannerImageDescriptive";
import CTABannerSplitTiles from "@/components/centralbrisbanedental/CTABannerSplitTiles/CTABannerSplitTiles";
import TwoColumnContent from "@/components/centralbrisbanedental/TwoColumnContent/TwoColumnContent";
import ContentBackgroundImage from "@/components/centralbrisbanedental/ContentBackgroundImage/ContentBackgroundImage";
import Footer from "@/components/centralbrisbanedental/Footer/Footer";
import PageHeader from "@/components/centralbrisbanedental/page/Header/Header";
import FAQ from "@/components/centralbrisbanedental/FAQ/FAQ";
import Callout from "@/components/centralbrisbanedental/Callout";
import Tabs from "@/components/centralbrisbanedental/Tabs/Tabs";


const fileLabel = 'pages/index';
const logger = createLogger({ // eslint-disable-line no-unused-vars,@typescript-eslint/no-unused-vars
  fileLabel,
});

/**
 * Only executed on the server side at build time.
 * Necessary when a page has dynamic routes and uses "getStaticProps".
 */
// export const getStaticPaths: GetStaticPaths<CommonServerSideParams> = getPublicLayoutStaticPaths({fallback:true});
// export const getStaticPaths: GetStaticPaths<CommonServerSideParams> = getPublicLayoutStaticPaths();

/**
 * Only executed on the server side at build time.
 *
 * @return Props (as "SSGPageProps") that will be passed to the Page component, as props.
 *
 * @see https://github.com/vercel/next.js/discussions/10949#discussioncomment-6884
 * @see https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 */
export const getStaticProps: GetStaticProps<SSGPageProps, CommonServerSideParams> = async (props: StaticPropsInput): Promise<GetStaticPropsResult<SSGPageProps>> => {
  const commonStaticProps: GetStaticPropsResult<SSGPageProps> = await getWebLayoutStaticProps()(props);
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('getStaticProps commonStaticProps', commonStaticProps); // eslint-disable-line no-console
  }
  if ('props' in commonStaticProps) {
    const config = getReactDivApiConfig();

    const [
      // Below is Web Module
      // currentShelledPage,
      // currentClientProjectSEOSettings,
      // currentShelledPageSeoSettings, // NOTE This is a dependency, should loop through these
      // currentClientProjectSEOSettings,
      // Above is Web Module
    ] = await Promise.all([
      // Below is Web Module
      // getShelledPageBySingularAPIID({config, slug: 'home'}),
      // getSystemShelledFieldsBySystemShellID({config, systemShellID: '630f756db23725aedbc16e7d'}),
      // getClientProjectContentBySystemShellID({
      //   config,
      //   clientID: commonStaticProps.props.reactDivClientID,
      //   projectID: commonStaticProps.props.reactDivClientProjectID,
      //   systemShellID: '630f756db23725aedbc16e7d',
      // }),
      // getBySingularAPIID({config, slug: "home"}),
      // Above is Web Module
    ]);

    return deepmerge(commonStaticProps, {
      props: {
        // Below is Web Module
        // currentShelledPage,
        // currentShelledPageSeoSettings,
        // currentClientProjectSEOSettings,
        // Above is Web Module
        builtAt: new Date().toISOString(),
      },
      // revalidate: regenerationDelay,
    });
    // return commonStaticProps;
  } else {
    return commonStaticProps;
  }
};

/**
 * SSG pages are first rendered by the server (during static bundling).
 * Then, they're rendered by the client, and gain additional props (defined in OnlyBrowserPageProps).
 * Because this last case is the most common (server bundle only happens during development stage), we consider it a default.
 * To represent this behaviour, we use the native Partial TS keyword to make all OnlyBrowserPageProps optional.
 *
 * Beware props in OnlyBrowserPageProps are not available on the server.
 */
type Props = {} & SSGPageProps<Partial<OnlyBrowserPageProps>>;

let teethWhiteningContentA: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Over time the appearance and ' +
              'attractiveness of our teeth will change.  Stains and discolouration on the tooth surface can be caused by things like tobacco, alcohol, coffee, tea and even certain mouth rinses.  Sometimes our teeth are exposed to trauma, or affected by medications.  As we get older in general our teeth will start to show their age.  There are lots of reasons why your teeth may no longer be the sparkling, pearly whites they used to be.  This is when you may find yourself at the dentist wanting a teeth whitening service.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Our dentists know how important it is to our ' +
              'patients to have professional teeth whitening that leaves a lasting result.  The good news about professional teeth whitening is that it can be done with very little or no side effects.  Sometimes when your teeth are whitened you may experience some tooth sensitivity.  Usually this side effect is very mild and short lived.  It generally stops after the treatment is completed.  We take precautions to minimise the occurrence of tooth sensitivity by using whitening agents that include anti-sensitivity and tooth strengthening products.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'relaxed dental patient receiving treatment',
              src: '/static/images/tiles/sunbaking-toothy-teeth-whitening.png.webp',
              height: 320,
              width: 463,
            },
            imageClasses: {
              textAlign: "center"
            }
          }
        ]
      },
    ]
  },
]
let teethWhiteningContentB: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'To keep up with our desire for whiter teeth, ' +
              'there are many teeth whitening products available.  However, you should be very careful about what you place on your teeth or who you allow to do this.  Dentists are the only ones qualified to assess and determine if your teeth are suitable for teeth whitening.  Over the counter teeth whitening products and untrained operators offering teeth whitening treatments have been the cause of much publicised teeth and gum damage.  If you are serious about getting whiter teeth, please discuss with your dentist whether tooth whitening is suitable for you and which systems are best for your situation.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Our team opts to use two methods that are ' +
              'both safe and effective.  Professionally-Guided Take-Home Teeth Whitening is where low concentration whitening agent is worn in custom-fit trays.  These trays sit over the teeth at home while you sleep or approximately 90 minutes a day to give whiter teeth slowly over 2 weeks.  In-Office or In-Chair Power Teeth Whitening is where high concentration whitening agent is placed directly on the teeth in the surgery and activated with a special light to give whiter teeth immediately.  This method gives the best result as it is controlled by the dentist.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'heading',
            type: 'h3',
            value: 'What Happens When I Get Zoomed?',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontWeight: "bold",
              fontSize: "text-2xl",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Zoom! in-chair teeth whitening is the best we ' +
              'have available.  An appointment usually lasts 1.5 hours and involves:',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'richList',
            type: 'ul',
            value: [
              "An assessment to make sure your teeth are suitable",
              "Recording of starting colour",
              "Pumicing of the teeth",
              "Placing barriers to protect the soft tissues",
              "Placing high concentration whitening gel",
              "Activating gel with special Zoom lamp",
              "Up to 3 x 15 minute rounds of whitening",
              "Removal of gel and barriers",
              "Comparing end colour with starting colour"
            ]
          }
        ]
      },
    ]
  },
]
let teethWhiteningContentC: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Tooth whitening should occur before any ' +
              'restorative dental work like fillings, veneers and crowns if the colour of the natural teeth is not desired.  Fillings, veneers and crowns can be matched to the colour of the whitened teeth very easily, but it is very difficult to match teeth whitening to existing fillings and crowns as they do not whiten.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'At Central Brisbane Dental, we use Pola Night ' +
              'as our take-home whitening system because it is safe to use during the day as well as overnight. Pola Night whitening gels are high viscosity and are neutral in pH to ensure greatest patient comfort during use in custom-made trays.  The gels contain soothers and conditioners with a high water content to help reduce the risk of sensitivity and include fluoride to remineralise the teeth.  Central Brisbane Dental choses to use the famous Philips Zoom! system for our in-office whitening because it gives the whitest teeth in the safest possible way.  Besides clinically proven to whiten teeth up to 8 shades lighter, the Philips Zoom! in-office whitening system also contains ACP (amorphous calcium phosphate), which is clinically proven to reduce sensitivity, protect enamel and improve the luster and smoothness of your teeth.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'relaxed dental patient receiving treatment',
              src: '/static/images/tiles/teeth-whitening.png.webp',
              height: 320,
              width: 463,
            },
            imageClasses: {
              textAlign: "center"
            }
          }
        ]
      },
    ]
  },
]

/**
 * Example of a public page.
 */
const Index: NextPage<Props> = (props): JSX.Element => {
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('Index props', props); // eslint-disable-line no-console
  }
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
    };
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <>
      <div className="sticky top-0 z-10 shadow-md">
        <Annoucement
          mobilePrimaryTextValue="Extracted publication of ClearPath Orthocare case study by Dr Vincent Wan."
          desktopPrimaryTextValue="Extracted publication of ClearPath Orthocare case study by Dr Vincent Wan."
          tailwindWrapperClassNames={{
            tailwind: "bg-[#400068]"
          }}
          tailwindContainerClassNames={{
            tailwind: "mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8 flex flex-wrap items-center justify-between"
          }}
          destination="/static/pdf/case-study-dr-wan.pdf"
        />
        <Topbar
          scrollY={scrollY}
          style={{
            background: "bg-[#f3f3f3]"
          }}
        />
      </div>
      <NavBar/>
      <PageHeader
        title="Teeth Whitening Brisbane"
        background="bg-[#400068]"
        backgroundImage="/static/images/headers/life-cycle-header-overlay.png"
      />
      <main>
        <TwoColumnContent
          title="Sit Back While We Brighten Your Day!"
          // heading="How to get to our dental clinic in Brisbane city & things to know before coming in."
          content={teethWhiteningContentA}
        />
        <Callout
          mobilePrimaryTextValue="More information about teeth whitening"
          desktopPrimaryTextValue="More information about teeth whitening"
          iconColour={"#400068"}
          textClassNames={{
            colour: "text-black"
          }}
          tailwindWrapperClassNames={{
            tailwind: "bg-[#17AAAB]"
          }}
          tailwindContainerClassNames={{
            tailwind: "mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8 flex flex-wrap items-center justify-between"
          }}
          destination="/static/pdf/Central-Brisbane-Dental-Teeth-Whitening.pdf"
        />
        <Tabs
          wrapperClassNames={{
            background: "bg-[#400068]"
          }}
          containerClassNames={{
            spacing: "container mx-auto",
            padding: "py-8"
          }}
          heading="Teeth Whitening Brisbane"
          headingClassNames={{
            fontSize: "text-2xl md:text-3xl",
            fontWeight: "font-bold",
            color: "text-white",
            padding: "py-4 px-4 md:px-0",
            alignment: "text-center md:text-left"
          }}
          headingEmphasis="Procedure and Cost"
          headingEmphasisClassNames={{
            color: "text-[#ff6600]"
          }}
          tabs={[
            {
              heading: "1.5 Hour Appointment – Free Cosmetic Consult",
              items: [
                {
                  heading: "Item 014 - Free cosmetic consult",
                  content: [
                    `<strong>Description:</strong> Usually 12-20 teeth need to be whitened.`,
                    `<strong>Cost:</strong> Free, normally $66.`
                  ]
                },
                {
                  heading: "Item 118 x the number teeth to be whitened",
                  content: [
                    `<strong>Description:</strong> Free cosmetic consult to check if suitable for teeth whitening`,
                    `<strong>Cost:</strong> $600.`
                  ]
                },
                {
                  heading: "Item 999 - GST",
                  content: [
                    `<strong>Description:</strong> Teeth whitening is one of the only dental treatments that attract GST`,
                    `<strong>Cost:</strong> $60.`
                  ]
                }
              ]
            },
          ]}
        />
        <CTABannerImageDescriptive
          imageProperties={{
            layout: 'intrinsic',
            alt: 'happy toothy character',
            type: 'dimensions',
            src: '/static/images/tiles/sunbaking-toothy-teeth-whitening.png.webp',
            height: 285,
            width: 412.5,
          }}
          title="Philips Zoom"
          heading="Teeth Whitening for just $660!"
          description="Come in for a free consultation."
          buttonText="View terms and conditions"
          buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
          imageClasses={{
            textAlign: "center",
            padding: "p-5"
          }}
          titleClasses={{
            dynamicColour: '#ff6600',
            fontSize: 'text-base',
            fontWeight: 'semibold',
            letterSpacing: 'tracking-wider',
            uppercase: true,
          }}
          headingClasses={{
            margin: 'mt-2',
            fontSize: 'text-2xl sm:text-3xl',
            fontWeight: 'extrabold',
            letterSpacing: 'tracking-tight',
            colour: 'text-white',
          }}
          descriptionClasses={{
            margin: 'mt-3',
            fontSize: 'text-lg',
            colour: 'text-white'
          }}
          buttonClasses={{
            border: 'border border-transparent rounded-md',
            display: 'inline-flex',
            padding: 'px-5 py-3',
            dynamicBackground: '#17aaab',
            fontSize: 'text-base',
            fontWeight: 'medium',
            colour: 'text-black',
          }}
          classes={{
            position: 'relative',
            dynamicBackground: '#070707',
          }}
        />
        <FAQ
          enableHeading={true}
          faqs={[
            {
              question: "Do Teeth Whiteners Damage Teeth?",
              answer: "For any teeth whitening, even whitening that you perform yourself, you should always consult the advice of a dentist. There are many DIY whitening products on the market and many of them can cause damage to teeth. Your overall dental health should be factored into the decision of whether or not to undergo a whitening treatment. Professional teeth whitening can be more expensive than over the counter alternatives but the results are often more long term and are performed by a professional who can consider your current dental health state and whether you are suitable for teeth whitening."
            },
            {
              question: "Is Whitening Bad For Your Teeth?",
              answer: "If your teeth are unhealthy, teeth whitening should not be performed as there is a high risk of damage.  For example, if you have tooth decay and the teeth whitening agent gets into it, you may experience pain as the whitening gel penetrates deeper into your teeth than it was supposed to.  If a dentist has checked your teeth and deemed that you are suitable for teeth whitening, then there should be no issues with going ahead with the treatment.  Sensitivity may be a side effect of teeth whitening, but this is reversible, transient and subsides within 24 hours.  Anti-sensitivity agents are added to whitening gels to lessen this side effect."
            },
            {
              question: "Can Yellow Teeth Become White?",
              answer: "It depends on the reason for the yellow colour.  If the yellow colour is caused by superficial staining of the teeth from what you eat and drink such as tea, coffee and red wine, then teeth whitening should be able to remove it and your teeth will be whiter.  However, if the yellow colour is due to a darkening of your tooth due to a knock to it, then teeth whitening may not be able to remove it.  Treatment of the cause of the darkening, such as root canal treatment for a dead nerve in the tooth from the knock, is required."
            },
            {
              question: "How Much Does It Cost For Professional Teeth Whitening?",
              answer: "At Central Brisbane Dental we provide professional in-chair teeth whitening for $660 (normally $990). This includes a cosmetic consultation to check your suitability for teeth whitening and a 1.5 hour appointment to whiten your teeth with the famous Philip’s Zoom system."
            },
            {
              question: "Is Teeth Whitening Permanent?",
              answer: "Unfortunately, our teeth will discolour over time with what we eat and drink and do to our teeth.  Professional in-chair whitening typically lasts for 2 years after which many patients opt to have it done again.  If you avoid things that stain your teeth like tea, coffee, red wine and smoking, and you practice good dental hygiene, your whitening result will last longer."
            },
            {
              question: "Do I Brush After Teeth Whitening?",
              answer: "Your dentist will advise you of any special steps you should take after a teeth whitening treatment, however as a general rule of thumb you should avoid eating, drinking or brushing your teeth for 30 minutes after an in-chair teeth whitening procedure.  The dentist usually places fluoride over your teeth after teeth whitening to strengthen and lessen the risk of sensitivity and this should be left for 30 minutes to allow full effect."
            }
          ]}
        />
        <TwoColumnContent
          title="Don't Just Paint Your Teeth White!"
          // heading="How to get to our dental clinic in Brisbane city & things to know before coming in."
          content={teethWhiteningContentB}
        />
        <CTABannerSplitTiles
          dentist="allen"
          heading="Did you know?"
          value="You can get 2 checkup and cleans a year for $0 or a very small out-of-pocket when you come and see us and use your health fund."
          buttonText="View terms and conditions"
          buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
          hasInset={true}
          insetClasses={{
            display: 'hidden lg:block',
            position: 'absolute top-0 inset-x-0',
            height: 'h-1/2',
            dynamicBackground: '#400068'
          }}
          buttonClasses={{
            border: 'border border-transparent rounded-md',
            display: 'inline-flex',
            padding: 'px-5 py-3',
            dynamicBackground: '#17aaab',
            fontSize: 'text-base',
            fontWeight: 'medium',
            colour: 'text-black',
          }}
          classes={{
            position: 'relative',
            dynamicBackground: '#fff',
            padding: 'py-16'
          }}
        />
        <TwoColumnContent
          title="We Only Use Proven Products!"
          // heading="How to get to our dental clinic in Brisbane city & things to know before coming in."
          content={teethWhiteningContentC}
        />
        {/* Content Layout Two - Repeated */}
        <section
          data-component-type="content-only"
        >

          <div
            className="container mx-auto flex"
          >

            <div className="w-full flex justify-end py-8">

              <div className="flex flex-col justify-center px-2">

                <h2 className="mt-2 text-black text-3xl font-extrabold tracking-tight sm:text-4xl text-center">
                  Can't I Just Use A <span className="text-[#17aaab]">Teeth Whitening At Home Kit</span>?
                </h2>

                <p className="mt-5 text-lg text-gray-900 mr-8">
                  Don’t be fooled by the abundance of teeth whitening at home kits available.  They range from teeth
                  whitening toothpaste, to teeth whitening brushes and pens, to teeth whitening gels in strips or used
                  in trays. Some even have a special teeth whitening light or lamp included. These products sold at the
                  shops or at pharmacies may promise the same results as getting professional teeth whitening at the
                  dentist. However, as evidenced by the numerous negative online reviews, these teeth whitening kits are
                  not very effective and don’t produce much teeth whitening. This is because teeth whitening kits sold
                  in Australia are heavily regulated. So that people don’t accidentally damage their teeth and gums, the
                  concentration of the teeth whitening ingredient must be low for at home use to be legally sold in
                  Australia. Unfortunately, the low concentration also leads to ineffective teeth whitening and poor
                  results. If you import a high concentration at home teeth whitening product from overseas or online,
                  it will be more effective, but there are also numerous online reviews telling stories of damaged teeth
                  and gums from such products. So if you are looking at teeth whitening, it is best to see a dentist for
                  it. Your dentist is most qualified to check your teeth and gums for teeth whitening suitability. At
                  our Brisbane CBD dental clinic, our dentists will honestly tell you if teeth whitening is right for
                  you or your teeth won’t change colour much. Teeth whitening will be carried out in a effective and
                  safe manner, giving the best results without damaging the teeth and gums. Whether you choose Zoom
                  in-chair teeth whitening with one of our Brisbane dentists or professionally-guided take-home teeth
                  whitening using our custom-made trays, you will receive the best teeth whitening available with a
                  scientifically proven product. Beware of cheap teeth whitening deals offered at beauty salons and
                  teeth whitening lounges that try to mimic the in-chair teeth whitening process at the dentist. The
                  teeth whitening there is often performed by an unqualified operator using lower concentration
                  whitening products that aren’t as effective at whitening, but can still damage the teeth and gums.
                  Only dentists can legally provide the highest concentration of teeth whitening product in Australia
                  for obvious safety reasons. So please forget about the cheap teeth whitening at home kit on sale at
                  Chemist Warehouse or a similar store, even if they allow you to use Afterpay or zipPay to purchase it.
                </p>

              </div>

            </div>

          </div>

        </section>
      </main>
      <Footer/>
    </>
  );
};

export default Index;
